var ipadPois = {
  ipadAir: {
    id: "ipadAir",
    name: "iPad Air",
    product: true,
    videos: [],
    actionButton: "Learn More",
    backButton: "products",
    html: "IpadAirPage",
    camera: {
      position: {
        x: 3000,
        y: 987,
        z: -2619,
      },
      rotation: {
        x: 0,
        y: -90,
        z: 0,
      },
      target: "button-ipadAir",
      fov: 60,
      wideFov: 55,
      interactive: false,
      clamped: true,
    },
  },
  ipad: {
    id: "ipad",
    name: "iPad",
    product: true,
    videos: [],
    actionButton: "Learn More",
    backButton: "products",
    html: "ipadPage",
    camera: {
      position: {
        x: 3000,
        y: 987,
        z: -2003,
      },
      rotation: {
        x: 0,
        y: -90,
        z: 0,
      },
      target: "button-ipad",
      fov: 60,
      wideFov: 55,
      interactive: false,
      clamped: true,
    },
  },
};
export default ipadPois;